'use strict';

function activateBySpaceButton(evt) {
  var $ = require('zepto');

  if (evt.key === ' ') {
    evt.preventDefault();
    evt.stopPropagation();
    $(evt.target).click();
  }
}

function activateBySpaceOrEnterButton(evt) {
  var $ = require('zepto');

  if (evt.key === 'Enter') {
    evt.preventDefault();
    evt.stopPropagation();
    $(evt.target).click();
    return;
  }

  activateBySpaceButton(evt);
}

module.exports = {
  activateBySpaceButton: activateBySpaceButton,
  activateBySpaceOrEnterButton: activateBySpaceOrEnterButton
};
//# sourceMappingURL=keyboardInteractions.js.map